import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
export const StackoverflowIcon = t0 => {
  const $ = _c(6);
  let svg;
  if ($[0] !== t0) {
    ({
      ...svg
    } = t0);
    $[0] = t0;
    $[1] = svg;
  } else {
    svg = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fill="currentColor" d="M84.4 93.8V70.6h7.7v30.9H22.6V70.6h7.7v23.2z" />;
    t2 = <path fill="currentColor" d="M38.8 68.4l37.8 7.9 1.6-7.6-37.8-7.9-1.6 7.6zm5-18l35 16.3 3.2-7-35-16.4-3.2 7.1zm9.7-17.2l29.7 24.7 4.9-5.9-29.7-24.7-4.9 5.9zm19.2-18.3l-6.2 4.6 23 31 6.2-4.6-23-31zM38 86h38.6v-7.7H38V86z" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== svg) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 120 120" fill="none" {...svg}>{t1}{t2}</svg>;
    $[4] = svg;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
StackoverflowIcon.displayName = "StackoverflowIcon";